export const {
  REACT_APP_API_BASE_URL,
  REACT_APP_ENVIRONMENT = 'dev',
  REACT_APP_PUSHER_KEY,
  REACT_APP_PUSHER_CLUSTER
} = process.env;
export const isDevEnvironment = ['dev', 'qa'].includes(REACT_APP_ENVIRONMENT as string);
